var render = function render(_c,_vm){return _c('span',{staticClass:"overlay",class:`absolute inset-0 z-20 opacity-${_vm.props.dimRatio || '50'} bg-${_vm.props.overlayColor || 'black'} ${_vm.data.staticClass ? _vm.data.staticClass : ''}`})
}
var staticRenderFns = []

export { render, staticRenderFns }